// MSAL v5 redirect bridge, handled in src/index.tsx; registered as an SPA redirect URI in the B2C app registrations
export const REDIRECT_BRIDGE_PATH = '/redirect';

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_ADMINUI_CLIENT_ID ? import.meta.env.VITE_AUTH_ADMINUI_CLIENT_ID : '',
    authority: `https://${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_AUTH_TENANT_ID}/${import.meta.env.VITE_AUTH_USER_FLOW}`,
    knownAuthorities: [`${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com`],
    redirectUri: `${window.location.origin}${REDIRECT_BRIDGE_PATH}`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    iframeBridgeTimeout: 10000,
  },
};

export const loginRequest = {
  scopes: [`https://${import.meta.env.VITE_AUTH_TENANT_NAME}.onmicrosoft.com/paiadminapi/admin_scope`],
};
